export const accessCodeSelector = (workspaceKey, resourceKey) => state => {
    if (!Boolean(workspaceKey) || !Boolean(resourceKey)) {
        return null;
    }

    const credentials = state.accessCredentials[workspaceKey];
    return credentials ? credentials[resourceKey] : null;
}